import React__default from 'react';
import { mobile, app, dom, api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { toggleModal } from '../modal/legacy-modal/index.js';
import { isPidExist, openAppInBiliApp, downloadApp } from './utils/index.js';

function openApp(target) {
  var openAppParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = target.type,
      path = target.path,
      options = target.options;
  var _openAppParams$messag = openAppParams.message,
      message = _openAppParams$messag === void 0 ? '下载 APP 发现更多有趣内容 >w<' : _openAppParams$messag,
      bili = openAppParams.bili,
      modalClassName = openAppParams.modalClassName; // 启用 bili 环境下的特殊逻辑，可以使用 bilibili JSB 的特殊能力

  if (bili) {
    /* 如果存在 pid，说明用户想要在啊B app 广告容器投放页面，此时兜底操作变为直接通过渠道下载 app。
     * 如果存在 bid，说明用户想要在啊B app 主站容器投放页面。
     */
    var pidExist = isPidExist();

    if (mobile.isInBiliApp() && !pidExist) {
      // 如果页面**不是**作为在广告容器中投放的页面，又恰巧处于主站容器中，那么我们可以利用啊B JSB 的能力
      // NOTICE: iOS 因底层漏洞可以在广告容器使用 js-bridge，但会出现奇怪的问题
      openAppInBiliApp(path !== null && path !== void 0 ? path : '', type, options);
      return;
    }

    if (pidExist && mobile.isInNormalBrowser()) {
      /**
       * 如果页面是作为在广告容器中投放的页面，又属于可以静默调起 app 且可以直接下载应用安装包的浏览器，那么尝试直接调起，
       * 如果调起不成功，直接通过渠道下载 app。
       * 特殊情况：
       *  - 在微信或 QQ 内置浏览器，无法唤起 APP
       *  - 在未安装 app 的情况下，在 Safari 打开 Scheme 会弹出错误提示窗
       * 以上情况 fallback 到使用弹窗的方式
       */
      // bilibili app 广告容器
      var _app$getAppLink = app.getAppLink({
        type: type,
        path: path,
        options: options
      }),
          url = _app$getAppLink.url;

      dom.checkDocumentHidden(function () {
        downloadApp();
      });
      window.location.href = url;
      return;
    } // 如果不满足上面两个情况，fallback 到弹窗

  } // 普通情况


  toggleModal({
    title: /*#__PURE__*/React__default.createElement("div", {
      className: "modal-open-app-title"
    }, "\u8BF7\u5148\u4E0B\u8F7D\u5BA2\u6237\u7AEF"),
    className: classNames('open-app', modalClassName),
    type: 'confirm',
    params: {
      messageText: message,
      cancelText: '我知道了',
      confirmText: '前去下载',
      onConfirm: function onConfirm() {
        window.open("".concat(api.MISSEVAN_MOBILE_API_PREFIX_URL, "/app"), '_blank');
      }
    }
  });
  app.openAppByProtocol(path !== null && path !== void 0 ? path : '', type, options);
}

export { openApp };
